export default {
  IDCLINE: 3
};



// WEBPACK FOOTER //
// ./src/lib/global.js